<app-modal [heading]="title" [submitLabel]="saveLabel" [formGroup]="form" (submitted)="submit()">
  <!--
    🚨 N8 — the register is append-only. A correction does NOT overwrite the
    entry: it withdraws it and declares a new one, and both stay on record
    attributed to whoever made each act. The person is told that here, before
    they save, because a form that looks like an edit and quietly appends a
    retraction misrepresents what they are doing.
  -->
  @if (isCorrection) {
    <p class="decl-dialog__note" data-testid="decl-dialog-correction-note">
      The entry you are correcting stays on record, attributed to whoever made it. Your correction
      is added alongside it as a new entry.
    </p>
  }

  <div class="decl-dialog__form">
    @if (data.kind === 'FUNDER') {
      <mat-form-field appearance="outline">
        <mat-label>Funder name</mat-label>
        <input matInput formControlName="funder_name" data-testid="decl-funder-name" />
        <mat-error data-testid="decl-dialog-error">Enter a name before saving this.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Type of finance</mat-label>
        <mat-select formControlName="facility_type">
          @for (opt of facilityTypes; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Is it still running?</mat-label>
        <mat-select formControlName="facility_state">
          @for (opt of facilityStates; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="decl-dialog__wide">
        <mat-label>Names their payments arrive under</mat-label>
        <input matInput formControlName="payer_names" placeholder="Separate with commas" />
        <mat-hint>A funder often pays under more than one name.</mat-hint>
      </mat-form-field>
    } @else if (data.kind === 'RELATED_PARTY') {
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="party_name" data-testid="decl-party-name" />
        <mat-error data-testid="decl-dialog-error">Enter a name before saving this.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>How they're connected</mat-label>
        <mat-select formControlName="relationship">
          @for (opt of relationships; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="decl-dialog__wide">
        <mat-label>Names their payments arrive under</mat-label>
        <input matInput formControlName="payer_names" placeholder="Separate with commas" />
      </mat-form-field>
    } @else {
      <mat-form-field appearance="outline">
        <mat-label>Full name</mat-label>
        <input matInput formControlName="full_name" data-testid="decl-director-name" />
        <mat-error data-testid="decl-dialog-error">Enter a name before saving this.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>ID or passport number</mat-label>
        <input matInput formControlName="id_number" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select formControlName="director_role">
          @for (opt of directorRoles; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
</app-modal>
